import { IonLabel, IonSegment, IonSegmentButton } from "@ionic/react";
import { useDispatch, useSelector } from "react-redux";
import { setSegmentSelected } from "../../../store/templateDetail";
import { selectSegmentSelected } from "../../../store/templateDetail/selectors/selectSegmentSelected";

export const SegmentsSection = () => {
  const dispatch = useDispatch();
  const segmentSelected = useSelector(selectSegmentSelected);
  
  return (
    <IonSegment
      onIonChange={(e) => {
        dispatch(setSegmentSelected(e.detail.value!));
      }}
      value={segmentSelected}
      color="primary"
    >
      <IonSegmentButton value="preview">
        <IonLabel>Vista Previa</IonLabel>
      </IonSegmentButton>
      <IonSegmentButton value="form">
        <IonLabel>Formulario</IonLabel>
      </IonSegmentButton>
    </IonSegment>
  );
};
